import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useOrderService } from "../../hooks";

export const DownloadData = () => {
  const { orderId, orderItemId } = useParams();
  const navigate = useNavigate();
  const orderService = useOrderService();

  useEffect(() => {
    orderService
      .GetOrderItemData(orderId!, orderItemId!)
      .then((result) => {
        window.open(result, "Download");
        navigate("/");
      })
      .catch(() => {});
  }, [orderId, orderItemId, orderService]);

  return null;
};
